<template>
    <div>
        <div class="video-item-wrapper" v-if="!showSelect">
            <CoverPanel
                :noCoverIcon="noCoverIcon"
                :imageUrl="data.cardImage"
                :operateIcons="operateIcons"
                :viewIcon="viewIcon"
                @viewClick="viewHandler"
                @uploadCover="uploadCover"
                @operatorSelect="operatorSelect"
            />
            <IconInput class="video-item-input" :placeholder="inputDescLabel" :initValue="data.name" @inputChange="descChange" />
            <HotPointPanel :data="hotPointData" @redSwitch="redSwitch" @hotSwitch="hotSwitch" @endDateChange="hotDateChange" v-if="isHlist" />
            <TransferIcon class="opr-transfer" v-show="isHlist" @transfer="tranferItem" />
            <DeleteIcon class="opr-delete" v-show="isHlist" @iconClick="deleteItem" />
        </div>
        <div class="item-selected" @mouseover="onMouseover" @mouseout="onMouseOut" v-else>
            <SelectItem :itemData="itemData" @itemSelect="selectItemType" />
            <DeleteIcon v-show="showDelete && isHlist" class="opr-delete" @iconClick="deleteItemVideo" />
        </div>
    </div>
</template>

<script>
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import HotPointPanel from "../HotPointPanel";
import CoverPanel from "@/views/zhiji/components/coverPanel/CoverPanel";
import SelectItem from "@/views/zhiji/components/coverPanel/SelectItem";

import { isArray, isObject } from "@/views/zhiji/js/common/util.js";

export default {
    name: "VideoItem",
    props: ["data", "parentUId", "isHlist"],
    components: {
        TransferIcon,
        DeleteIcon,
        IconInput,
        HotPointPanel,
        CoverPanel,
        SelectItem
    },
    data() {
        return {
            showSelect: true,
            viewIcon: {
                position: "-60px -85px"
            },
            showDelete: false
        };
    },
    computed: {
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        },
        inputDescLabel() {
            return this.$t("zhiji.answer.inputDesc");
        },
        noCoverIcon() {
            return {
                position: "-172px -50px",
                label: this.$t("zhiji.answer.addVideo")
            };
        },
        operateIcons() {
            return [
                {
                    type: "edit",
                    position: "-296px 1px",
                    name: this.$t("zhiji.materialLibrary.editVideo")
                },
                {
                    type: "delete",
                    position: "-96px 0",
                    name: this.$t("zhiji.answer.deleteVideo")
                }
            ];
        },
        itemData() {
            return [
                {
                    type: "reference",
                    position: "-383px -1px",
                    name: this.$t("zhiji.answer.reference"),
                    iconClass: "reference-icon"
                },
                {
                    type: "create",
                    position: "-198px -50px",
                    name: this.$t("zhiji.answer.create")
                }
            ];
        }
    },
    mounted() {
        this.data.resourceId && this.data.cardImage && (this.showSelect = false);
    },
    methods: {
        tranferItem(event) {
            this.zhiji.dragStart(event, "h-list-item", "h", newIdx => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferContentItem",
                    widget: {
                        uId: this.parentUId,
                        item: {
                            newIdx: newIdx,
                            uId: this.data.uId
                        }
                    }
                });
            });
        },
        deleteItem() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.answer.delCardTips"),
                    cancel: () => {
                        this.$emit("closeModal");
                    },
                    confirm: () => {
                        this.deleteItemHandle();
                    }
                }
            });
        },
        deleteItemVideo() {
            this.deleteItemHandle();
            this.$emit("deleteItem");
        },
        deleteItemHandle() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "deleteContentItem",
                widget: {
                    uId: this.parentUId,
                    item: {
                        uId: this.data.uId
                    }
                }
            });
        },
        onMouseover() {
            this.showDelete = true;
        },
        onMouseOut() {
            this.showDelete = false;
        },
        descChange(newVal) {
            this.commitUpdate({
                name: newVal
            });
        },
        redSwitch(redState) {
            this.commitUpdate({
                redState: redState
            });
        },
        hotSwitch(hotItem) {
            this.commitUpdate({
                hotItem: hotItem
            });
        },
        hotDateChange(dateStr) {
            this.commitUpdate({
                redHotEndTime: dateStr
            });
        },
        viewHandler() {
            this.zhiji
                .requestByServiceName("queryVLinkVideo", {
                    videoId: this.data.resourceId
                })
                .then(result => {
                    this.$store.dispatch("zhiji/showModal", {
                        type: "VideoViewModal",
                        data: {
                            url: result.videoData[0].videoUrl
                        }
                    });
                });
        },
        uploadCover() {
            this.manualEdit();
        },
        selectItemType(item) {
            let handler = {
                reference: this.referenceEdit,
                create: this.manualEdit
            };
            handler[item.type].call(null);
        },
        operatorSelect(type) {
            if (type === "edit") {
                this.zhiji
                    .requestByServiceName("queryVLinkVideo", {
                        videoId: this.data.resourceId
                    })
                    .then(result => {
                        this.$store.commit("zhiji/showModal", {
                            type: "VideoEditModel",
                            data: {
                                type: "edit",
                                childModel: true,
                                videoData: result.videoData[0],
                                confirm: data => {
                                    this.commitUpdate({
                                        cardImage: data.url,
                                        url: data.videoUrl,
                                        name: data.title,
                                        videoSize: data.videoSize,
                                        videoTime: data.duration,
                                        videoId: data.videoId
                                    });
                                }
                            }
                        });
                    });
            }

            if (type === "delete") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: this.$t("zhiji.answer.hListWidge.delVideoConf"),
                        cancel: () => {},
                        confirm: () => {
                            this.commitUpdate({
                                resourceId: "",
                                cardImage: "",
                                url: "",
                                name: "",
                                videoSize: "",
                                videoTime: "",
                                videoId: ""
                            });
                            this.showSelect = true;
                        }
                    }
                });
            }
        },
        commitUpdate(updateData) {
            updateData.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: this.isHlist ? "updateContentItem" : "updateContent",
                widget: this.isHlist
                    ? {
                          uId: this.parentUId,
                          item: updateData
                      }
                    : updateData
            });
        },
        referenceEdit() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "video",
                    confirm: result => {
                        let updateData = "";
                        !isArray(result) && isObject(result) ? (updateData = result) : (updateData = result[0]);
                        let addData = isArray(result) && result.slice(1);
                        this.commitUpdate({
                            resourceId: updateData.id,
                            cardImage: updateData.url,
                            url: updateData.videoUrl,
                            name: updateData.title,
                            videoSize: updateData.videoSize,
                            videoTime: updateData.duration,
                            videoId: updateData.videoId
                        });
                        isArray(result) && this.addContentItem(addData);
                        this.showSelect = false;
                        this.$emit("selectClick", this.data);
                    }
                }
            });
        },
        addContentItem(data) {
            data.forEach(item => {
                let curItem = {
                    type: "video",
                    cardImage: item.url,
                    url: item.videoUrl,
                    name: item.title,
                    resourceId: item.id,
                    videoSize: item.videoSize,
                    videoTime: item.duration,
                    videoId: item.videoId
                };

                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: this.isHlist ? "addContentItem" : "addContent",
                    widget: this.isHlist
                        ? {
                              uId: this.parentUId,
                              item: {
                                  ...curItem
                              }
                          }
                        : {
                              uId: this.data.uId,
                              ...curItem
                          }
                });
            });
        },
        manualEdit() {
            this.$store.dispatch("zhiji/showModal", {
                type: "VideoEditModel",
                data: {
                    type: "add",
                    videoData: {},
                    childModel: true,
                    confirm: data => {
                        this.commitUpdate({
                            resourceId: data.id,
                            cardImage: data.url,
                            url: data.videoUrl,
                            name: data.title,
                            videoSize: data.videoSize,
                            videoTime: data.duration,
                            videoId: data.videoId
                        });
                        this.showSelect = false;
                        this.$emit("selectClick", this.data);
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.video-item-wrapper {
    position: relative;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 12px;
    flex-shrink: 0;
    width: 200px;
    .opr-transfer {
        display: none;
        z-index: 1;
        top: -21px;
        left: -2px;
        position: absolute;
    }

    .opr-delete {
        display: none;
        z-index: 1;
        right: -9px;
        top: -9px;
        position: absolute;
    }

    &:hover {
        .opr-transfer {
            display: inline-flex;
        }

        .opr-delete {
            display: inline-block;
        }
    }
}

.item-selected {
    position: relative;

    .opr-delete {
        position: absolute;
        top: -9px;
        right: 9px;
    }
}
</style>
